import { gql } from '@apollo/client'
import { TRAINING_FRAGMENT } from '../fragments/TrainingFragment'

export const GET_ALL_TRAININGS = gql`
  query Trainings {
    trainings {
      ...Training
    }
  }
  ${TRAINING_FRAGMENT}
`
